import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    defaultDisabledTooltipText: string;
    labelShare: string;
    labelExistingShares: string;
    labelSharesList: string;
    labelSharesListDescription: (count: number) => string | React.ReactNode;
    newShare: string;
    noResults: string;
    searchPlaceholder: (count: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** a message to display when sharing is disabled */
            defaultDisabledTooltipText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.defaultDisabledTooltipText?c=8sofhtwbgqfp", defaultMessage: "Sharing is disabled" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the 'add to share links' menu item */
            labelShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.labelShare?c=3i5mwntyjh5tu", defaultMessage: "Add to Share Links" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the 'add to existing share links' menu item */
            labelExistingShares: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.labelExistingShares?c=33qgnw6rvhs4l", defaultMessage: "Add to Existing Share Links" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the 'existing share links' header */
            labelSharesList: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.labelSharesList?c=2cnext2jb791v", defaultMessage: "Existing Share Links" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the 'shares list description' */
            labelSharesListDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.labelSharesListDescription?c=2xb64pi44gtr2", defaultMessage: "Showing {count} share links" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** a text for the 'new share link' button */
            newShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.newShare?c=2qfonbxvhuky5", defaultMessage: "New Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a message to display when there are no results */
            noResults: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.noResults?c=15vfa2y8e6jfy", defaultMessage: "No results" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a placeholder for the search input */
            searchPlaceholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "AddToShareSubmenu.searchPlaceholder?c=3383el2cver8t", defaultMessage: "Search {count} Share Links" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
